import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { useLayoutConstants } from "@BehpardazBarin/frontend_components";
import { useLocation } from "react-router-dom";

const Footer: React.FC = () => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const { isMobile } = useLayoutConstants(pathname);
  return (
    <Typography
      variant="body2"
      component="div"
      mt={2}
      mb={2}
      textAlign="center"
      sx={{
        fontSize: isMobile ? "12px" : "14px",
        fontFamily: "IRANSansX",
        color: theme.palette.text.primary,
      }}
    >
      <Box sx={{ fontFamily: "IRANSansXBold" }}>شماره تلفن - شماره نمابر</Box>
      <br />
      <strong
        style={{
          fontSize: isMobile ? "14px" : "18px",
        }}
      >
        ۰۳۱۳۳۹۴۴۰۰۰ - ۰۳۱۳۲۲۲۹۲۶۷
      </strong>
      <br />
      <Box sx={{ textAlign: "center", my: 2 }}>
        <Typography variant="caption">{`نسخه ${process.env.REACT_APP_VERSION}`}</Typography>
      </Box>
    </Typography>
  );
};

export default Footer;
